import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import school from "./slices/schoolSlice";
import poses from "./slices/poseSlice";
import users from "./slices/userSlice";
import classes from "./slices/classanddivSlice";
import students from "./slices/studentSlice";
import groupPhotos from "./slices/groupPhotoSlice";
import packages from "./slices/packageSlice";
import country from "./slices/countrySlice";
import parents from "./slices/parentSlice";
import images from "./slices/imageSlice";
import cms from "./slices/cmsSlice";
import photoGraph from "./slices/photographSlice";
import locations from "./slices/locationSlice";
import orders from "./slices/orderSlice";
import dashboard from "./slices/dashboardSlice";
import loadingSlice from "./slices/loadingSlice";
import maintenance from "./slices/maintenanceSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    school,
    poses,
    users,
    classes,
    students,
    groupPhotos,
    packages,
    country,
    parents,
    images,
    cms,
    locations,
    photoGraph,
    orders,
    dashboard,
    loadingSlice,
    maintenance,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
